import axios from 'axios';

let coreEndpoint = window.greenmotion ? window.greenmotion.coreEndpoint : '';

const http = axios.create({
    baseURL: coreEndpoint || API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

const locale = window.greenmotion ? window.greenmotion.locale : 'en';
const hasAuthenticatedFlag = 'authenticated' in window.greenmotion;
const authenticated = window.greenmotion ? window.greenmotion.authenticated : false;

http.interceptors.request.use(
    config => {
        return new Promise((resolve, reject) => {
            let config;

            try {
                config = Object.assign(
                    { currency: null, guestToken: null, userToken: null },
                    JSON.parse(localStorage.getItem('HTTP'))
                );
            } catch (exception) {
                config = Object.assign({ currency: null, guestToken: null, userToken: null });
            }

            resolve([config.currency, config.guestToken, config.userToken]);
        }).then(results => {
            if (results[0]) {
                config.headers['Accept-Currency'] = results[0];
            }

            if ((hasAuthenticatedFlag && authenticated && results[2]) || (!hasAuthenticatedFlag && results[2])) {
                config.headers['Authorization'] = `Bearer ${results[2]}`;
            } else if (results[1]) {
                config.headers['Guest-Authorization'] = `Token ${results[1]}`;
            }

            if (locale) {
                // TODO: Remove the "com-" replace once the locales system is complete
                config.headers['Accept-Language'] = locale.replace('com-', '');
            }

            return config;
        });
    },
    error => {
        // TODO: What kind of error needs handling here?
        return Promise.reject(error);
    }
);

export const HTTP_CONFIG = (currency, guestToken, userToken) => {
    localStorage.setItem('HTTP', JSON.stringify({ currency, guestToken, userToken, isLandingPage: false }));

    localStorage.setItem('currency', currency);
};

export const HTTP = http;
